import React from "react";
import PT from "prop-types";
import styled from "styled-components";
import { BlobBlock, Title, AsideIcon } from "./styled";
import ClockIcon from "_c/icon/Clock";
import AsideSchedule from "_c/modules/profile/common/AsideSchedule";

const Block = styled(BlobBlock)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  height: auto;
  color: #706671;
  @media (max-width: 991px) {
    justify-content: flex-start;
    align-items: flex-start;
  }
`;

const EnhancedTitle = styled(Title)`
  margin-bottom: 30px;
  align-self: flex-start;
  @media (max-width: 991px) {
    align-self: auto;
    margin-bottom: 35px;
  }
  @media (max-width: 575px) {
    align-self: auto;
    margin-bottom: 15px;
  }
`;
const ScheduleBlock = (props) => {
  if (!props.weekSchedule) return null;
  return (
    <Block isOwner={props.isOwner}>
      <AsideIcon>
        <ClockIcon color="var(--font-color-emp)" />
      </AsideIcon>
      <EnhancedTitle>{props.t("common:working_hours")}</EnhancedTitle>
      <AsideSchedule
        t={props.t}
        isSaloon
        scheduleLink="/salon/dashboard/settings"
        isOwner={props.isOwner}
        weekSchedule={props.weekSchedule}
      />
    </Block>
  );
};

ScheduleBlock.propTypes = {
  isOwner: PT.bool.isRequired,
  weekSchedule: PT.array,

  t: PT.func.isRequired,
};
export default ScheduleBlock;
